module.exports = __webpack_public_path__ + "img/quiz.018a5d02.png";